import React from 'react'
import getTransitionStyle from '../utils/getTransitionStyle'
import ThreeSixty from '../components/ThreeSixty'
import Modal from '../components/Modal'
import Footer from '../components/Footer'
import uniqBy from 'lodash.uniqby'
import Img from 'gatsby-image'
import Link from '../components/IntlLink'
import WorkTable from '../components/WorkTable'
import { Fade, Flip, Rotate, Zoom } from 'react-reveal';
import Menu from '../components/Menu'
import { FormattedMessage } from 'react-intl'
import PageAnimations from '../components/PageAnimations'
import { HelmetDatoCms } from 'gatsby-source-datocms'
import smoothScroll from 'smoothscroll';
import arrowLeft from '../images/arrow-circle-left.svg'
import arrowRight from '../images/arrow-circle-right.svg'
import Masonry from 'react-masonry-component';

const OptionalFade = (props) => {
  if (props.active) {
    return <Fade {...props} />
  }

  return <div>{props.children}</div>;
}

export default class Collection extends React.Component {
  constructor(props) {
    super(props);
    this.onKeyPressed = this.onKeyPressed.bind(this)
    this.state = {
      modal: null,
      selectedDesigner: 0,
      isOptionalFadeActive: true,
      additionalInput1: "High",
      additionalInput2: false,
      reversedFrames: []
    };
  }

  componentWillMount() {
    if (this.props.location.hash === "#customize") {
      setTimeout(() => {
        smoothScroll(this.workTableContainer, 2000)
      }, 5500)
    }
    if (typeof window !== `undefined`) {
      window.addEventListener("keydown", this.onKeyPressed);
    }
    const {collection} = this.props.data
    const frames = collection.threesixty.frames
    const firstFrameSrc =  frames[0].normal.src
    const adjustedFrames = firstFrameSrc.includes("_01") ?
      collection.threesixty.frames.reverse() :
      collection.threesixty.frames

    this.setState({reversedFrames: adjustedFrames})

  }

  componentWillUnmount() {
    if (typeof window !== `undefined`) {
      window.removeEventListener("keydown", this.onKeyPressed);
    }
  }

  handleSmoothScroll(e) {
    e.preventDefault();
    this.setState(
      { isOptionalFadeActive: false },
      () => smoothScroll(this.workTableContainer, 3000)
    );
  }

  handleChangeDesigner(e, designerIndex) {
    e.preventDefault()
    e.stopPropagation()
    this.setState({selectedDesigner: designerIndex})
  }

  handleSetWorkTable1(input) {
    this.setState({additionalInput1: input})
  }

  handleSetWorkTable2(input) {
    this.setState({additionalInput2: input})
  }

  onKeyPressed(e) {
    const {previousCollection, nextCollection} = this.props.data
    if (e.key === "ArrowLeft") {
      this.props.history.push(`${previousCollection.slug}`)
    } else if (e.key === "ArrowRight") {
      this.props.history.push(`${nextCollection.slug}`)
    }
  }

  renderMainDesigner(designer, index) {
    const className = ['collection__designers__avatar--main'];

    if (index === this.state.selectedDesigner) {
      className.push('is-active');
    }

    return (
      <div className="collection__designers__avatar__container" key={designer.name}>
        <div className={className.join(' ')}
          onClick={(e) => this.handleChangeDesigner(e, index)}
        >
          <img src={designer.avatar.resize.src}
            alt={designer.avatar.resize.alt}
            title={designer.avatar.resize.title}
            />
          <div className="collection__designers__name">{designer.name}</div>
        </div>
      </div>
    );
  }

  renderDesigner(designer) {
    return (
      <div className="collection__designers__avatar__container" key={designer.name}>
        <Link className="collection__designers__avatar" to={`/designers/${designer.slug}`}>
          <img
            src={designer.avatar.resize.src}
            title={designer.avatar.resize.title}
            alt={designer.avatar.resize.alt}
          />
        </Link>
      </div>
    );
  }

  renderGalleryImage(image, index) {
    return (
      <div key={image.id} className="masonry__item">
        <OptionalFade active={this.state.isOptionalFadeActive} bottom>
          <Img
            key={image.url + index}
            sizes={image.sizes}
            title={image.title}
            alt={image.alt}
          />
        </OptionalFade>
      </div>
    );
  }

  renderWorkTable() {
    const { collection } = this.props.data;
    let collectionCombos = collection.combos

    if (collection.name === "Stool Collection") {
      if (this.state.additionalInput2) {
        collectionCombos = collectionCombos.filter(
          combo => combo.name.includes("Cloverleaf")
        )
      } else {
        collectionCombos = collectionCombos.filter(
          combo => !combo.name.includes("Cloverleaf")
        )
      }
      collectionCombos = collectionCombos.filter(
        combo => combo.name.includes(this.state.additionalInput1)
      )
    }
    const skins = this.props.data.skins

    const baseBits = collectionCombos
      .reduce((a, b) => a.concat(b.baseBits.filter(bit => !bit.draft)), [])

    const optionalBits = collectionCombos
      .reduce((a, b) => a.concat(b.optionalBits.filter(bit => !bit.draft)), [])

    const isTall = collectionCombos.some(c => c.isTall);

    if (baseBits.length === 0 ) {
      return null;
    }

    if (baseBits.concat(optionalBits).some(bit => bit.colors.length === 0)) {
      return null;
    }

    const selectorGroupItemClassName = (state, value) => {
      const className = ["collection__selector__group__item"];
      if (this.state[state] === value) {
        className.push('is-active');
      }
      return className.join(' ');
    }

    return (
      <div ref={(el) => this.workTableContainer = el}>
        {
          collection.name === "Stool Collection" &&
            <div className="collection__selector">
              <div className="collection__selector__group">
                <button
                  className={selectorGroupItemClassName('additionalInput1', 'High')}
                  onClick={() => this.handleSetWorkTable1("High")}
                >
                  <FormattedMessage id="collection.group.high" />
                </button>
                <button
                  className={selectorGroupItemClassName('additionalInput1', 'Low')}
                  onClick={() => this.handleSetWorkTable1("Low")}
                >
                  <FormattedMessage id="collection.group.low" />
                </button>
              </div>
              <div className="collection__selector__group">
                <button
                  className={selectorGroupItemClassName('additionalInput2', false)}
                  onClick={() => this.handleSetWorkTable2(false)}
                >
                  <FormattedMessage id="collection.group.base" />
                </button>
                <button
                  className={selectorGroupItemClassName('additionalInput2', true)}
                  onClick={() => this.handleSetWorkTable2(true)}
                >
                  <FormattedMessage id="collection.group.cloverleaf" />
                </button>
              </div>
            </div>
        }
        <WorkTable
          key={`${this.state.additionalInput1}-${this.state.additionalInput2 ? 'true' : 'false'}`}
          isTall={isTall}
          baseBits={baseBits}
          optionalBits={optionalBits}
          collection={collection}
          isCollection={true}
          cssModifier="--collection"
          accessoriesModal={this.props.data.accessoriesModal.edges.map((x) => x.node)}
        />
      </div>
    )
  }

  renderOtherCollections() {
    const {previousCollection, nextCollection} = this.props.data
    const nextColor = nextCollection.color.hex
    const prevColor = previousCollection.color.hex
    const next360 = nextCollection.threesixty
    const prev360 = previousCollection.threesixty
    return(
      <div className="collection__half">
        <div className="collection__half__right" style={{backgroundColor: nextColor}}>
          <Link to={`/collection/${previousCollection.slug}`}>
            <div className="collection__half__container__right" to={`/collection/${nextCollection.slug}`}>
              {
                next360 && next360.frames.length > 6 &&
                  <Img sizes={next360.frames[7][next360.isTall ? 'tallSizes' : 'normalSizes']} />
              }
              {
                next360 && next360.frames.length === 1 &&
                  <Img sizes={next360.frames[0][next360.isTall ? 'tallSizes' : 'normalSizes']} />
              }
            </div>
            <p className="collection__half__title__right">
            {nextCollection.name}
            </p>
          </Link>
          <div className="collection__threesixty__next">
            <Link to={`/collection/${nextCollection.slug}`}>
              <img src={arrowRight}/>
            </Link>
          </div>
        </div>
        <div className="collection__half__left" style={{backgroundColor: prevColor}}>
          <Link to={`/collection/${previousCollection.slug}`}>
            <div className="collection__half__container__left">
              {
                prev360 && prev360.frames.length > 44 &&
                  <Img sizes={prev360.frames[41][prev360.isTall ? 'tallSizes' : 'normalSizes']} />
              }
              {
                prev360 && prev360.frames.length === 1 &&
                  <Img sizes={prev360.frames[0][prev360.isTall ? 'tallSizes' : 'normalSizes']} />
              }
            </div>
            <p className="collection__half__title__left">{previousCollection.name}</p>
          </Link>
          <div className="collection__threesixty__prev">
            <Link to={`/collection/${previousCollection.slug}`}>
              <img src={arrowLeft}/>
            </Link>
          </div>
        </div>
      </div>
    )
  }

  renderNews(news) {
    return (
      <Link to={`/news/${news.slug}`}
        className="news__half__item--collection"
        style={{backgroundImage: `url(${news.cover.resize.src})`}}
        key={`${news.slug}`}
      >
        <div className="news__half__container">
          <p className="page__text"> {news.date} </p>
          <h2 className="page__title"> {news.title} </h2>
        </div>
        <p className="page__text--abstract">
          {news.abstract}
        </p>
      </Link>
    )
  }

  render() {
    const { data, transition } = this.props;
    const status = transition ? transition.status : "entering"
    const timeout = 800
    const delay = 4000
    const collection = data.collection
    const menuStyle = getTransitionStyle(status, 200, 2000, 'menuStyle')


    const backgroundChange = {
      entering: {
        backgroundColor: 'transparent'
      },
      entered: {
        backgroundColor: `${collection.color.hex}`,
        transition: `all ${timeout}ms ${timeout}ms ease-in-out`,
      },
      exiting: {
        backgroundColor: `${collection.color.hex}`,
        transition: `all ${timeout}ms ${timeout}ms ease-in-out`,
      },
      exited: {
        backgroundColor: `${collection.color.hex}`,
      }
    }

    const sectionAppears = getTransitionStyle(
      status, timeout, 1000, 'pageAppearsFromBottom'
    )

    const baseDesigners = uniqBy(
      collection.combos.reduce((acc, combo) => (
        acc.concat(
          combo.baseBits
            .map(bit => bit.designer)
            .filter(x => !!x)
        )
      ), []),
      'name'
    )

    const topDesigners = uniqBy(
      collection.combos.reduce((acc, combo) => (
        acc.concat(
          combo.optionalBits
          .map(bit => bit.designer)
          .filter(x => !!x)
          .filter(x => !baseDesigners.map(x => x.name).includes(x.name))
        )
      ), []),
      'name'
    )

    const collectionDesigners = collection.designers.length > 0 ? collection.designers : baseDesigners

    const lineTransition = {
      entering: {
        width: 0,
      },
      entered: {
        width: `100%`,
        transition: `all 500ms ${delay}ms ease-in-out`,
      },
      exiting: {
      },
      exited: {
      },
    }

    var backgroundColor = {backgroundColor: `${collection.color.hex}`}
    var truncatedDesignerDescription = ''

    if (collectionDesigners.length > 0 && collectionDesigners[this.state.selectedDesigner].smallDescription) {
      const designerDescription = collectionDesigners[this.state.selectedDesigner].smallDescription.markdown.html

      truncatedDesignerDescription = (designerDescription.split(".").length > 5) ?
        designerDescription.split(".").slice(0, 5).join(".") + ".</p>" :
        designerDescription.substring(0, 300) + "[...]"
    }

    const selectedFrames = this.state.reversedFrames.map(f => (
      f[collection.threesixty.isTall ? 'tall' : 'normal'].src
    ))

    return (
      <div>
        <HelmetDatoCms
          seo={collection.seo}
          favicon={data.site.favicon}
        />

        <Menu
          style={menuStyle}
          hasWhiteLogo={true}
          data={data}
        />

        <div className="collection" style={{ ...backgroundChange[status]}}
            onKeyDown={this.onKeyPressed.bind(this)}
            tabIndex="0">
          <div className="collection__threesixty__container" style={sectionAppears}>
            <div style={sectionAppears} className="collection__threesixty">
              {
                collection.threesixty &&
                  <ThreeSixty
                    timeout={3500}
                    frames={selectedFrames}
                  />
              }
            </div>

            <div className="collection__header" style={sectionAppears}>
              <h1 className="collection__title">{collection.name}</h1>
              {
                collectionDesigners.length > 0 &&
                  <div className="page__flex--collection" >
                    <span style={sectionAppears}>
                      <FormattedMessage id="home.designBy" />
                    </span>
                    <div className="page__line">
                      <div style={{ ...lineTransition[status]}} />
                    </div>
                    <span style={sectionAppears}>
                      { collectionDesigners.map(d => d.name).join(', ')  }
                    </span>
                  </div>
              }

              <div className="collection__explore">
                {
                  this.props.data.collection.combos.length > 0 &&
                    <Link
                      style={sectionAppears}
                      className="button--dark"
                      to={`collection/${collection.slug}#worktable`}
                      onClick={this.handleSmoothScroll.bind(this)}
                    >
                      <FormattedMessage id="collection.customize" />
                    </Link>
                }
              </div>
            </div>
            <Link className="collection__threesixty__prev" to={`/collection/${data.previousCollection.slug}`}>
              <img src={arrowLeft}/>
              <span>{data.previousCollection.name}</span>
            </Link>
            <Link className="collection__threesixty__next" to={`/collection/${data.nextCollection.slug}`}>
              <span>{data.nextCollection.name}</span>
              <img src={arrowRight}/>
            </Link>

          </div>

          <div className="wrap">
            <div className="collection__section">
              <div className="collection__textbox" >
                <OptionalFade active={this.state.isOptionalFadeActive} bottom>
                  <h2 className="page__subtitle">
                    <FormattedMessage
                      id="collection.about"
                      values={{ name: collection.name }}
                    />
                  </h2>
                </OptionalFade>
                <OptionalFade active={this.state.isOptionalFadeActive} bottom>
                  <div dangerouslySetInnerHTML={{ __html: collection.about.markdown.html }} />

                  {
                    collection.priceStartingFrom &&
                      <div className="page__from">
                        <FormattedMessage
                          id="collection.from"
                          values={{ value: `${
                            Number.isInteger(collection.priceStartingFrom) ?
                            collection.priceStartingFrom :
                            collection.priceStartingFrom.toFixed(2)
                          }` }}
                        />
                        {

                        }
                      </div>
                  }

                  {
                    collection.buyLink &&
                      <a href={ collection.buyLink ? collection.buyLink : "/p/contact#eshop"} className="button--dark button--bigger" target="_blank">
                        <FormattedMessage id="collection.buyNow" />
                      </a>
                  }
                </OptionalFade>
              </div>
            </div>
          </div>

          <div className="wrap">
            <Masonry className="masonry" >
              { collection.gallery.map((image, index) => this.renderGalleryImage(image, index)) }
            </Masonry>
          </div>

          <a id="worktable" name="worktable" />

          <div className="interchangeability__section">
            { this.renderWorkTable() }
          </div>

          {
            collectionDesigners.length > 0 &&
              <div className="wrap">
                <div className="collection__section collection__section__last">
                  <h3 className="page__subtitle--collection">{this.props.data.collection.name}</h3>
                  <p className="page__text--collection">
                    <FormattedMessage id="home.collection" />
                  </p>
                  <div className="collection__designers">
                    { collectionDesigners.map((designer, index) => this.renderMainDesigner(designer, index)) }
                  </div>
                  <div className="collection__vertical-line"/>
                  {
                    collectionDesigners[this.state.selectedDesigner] &&
                      <div>
                        <div
                          className="collection__textbox"
                          dangerouslySetInnerHTML={{ __html: truncatedDesignerDescription }}
                        />
                        <Link
                          className="button--dark"
                          to={`/designers/${collectionDesigners[this.state.selectedDesigner].slug}`}>
                          <FormattedMessage id="collection.findOutMore" />
                        </Link>
                      </div>
                  }
                  {
                    topDesigners.length > 0 &&
                      <div className="collection__textbox">
                        <div className="page__small-title--collection">
                          <FormattedMessage id="collection.otherArtists" />
                        </div>
                        <div className="collection__designers">
                          { topDesigners.map(this.renderDesigner.bind(this)) }
                        </div>
                      </div>
                  }
                </div>
              </div>
          }
        </div>

        {
          collection.news.length > 0 &&
            <div className="wrap--large">
              <div className="news__half">
                { collection.news.map(news => this.renderNews(news)) }
              </div>
            </div>
          }

        {this.renderOtherCollections()}

        <PageAnimations
          status={status}
          timeout={timeout / 2}
          delay={timeout}
          color={collection.color.hex}
        />

        <Footer data={this.props.data} />
      </div>
    );
  }
}

export const query = graphql`
  query CollectionQuery($slug: String!, $locale: String!, $previousCollectionId: String, $nextCollectionId: String) {
    site: datoCmsSite {
      favicon: faviconMetaTags {
        ...GatsbyDatoCmsFaviconMetaTags
      }
    }

    nextCollection: datoCmsCollection(id: { eq: $nextCollectionId }) {
      slug
      name
      color {
        hex
      }
      threesixty {
        isTall
        frames {
          normalSizes: sizes(maxWidth: 300, imgixParams: { auto: "compress", rect: "300,400,840,900" }) {
            ...GatsbyDatoCmsSizes_noBase64
          }
          tallSizes: sizes(maxWidth: 300, imgixParams: { auto: "compress", rect: "300,600,840,900" }) {
            ...GatsbyDatoCmsSizes_noBase64
          }
        }
      }
    }

    previousCollection: datoCmsCollection(id: { eq: $previousCollectionId }) {
      slug
      name
      color {
        hex
      }
      threesixty {
        isTall
        frames {
          normalSizes: sizes(maxWidth: 300, imgixParams: { auto: "compress", rect: "300,400,840,900" }) {
            ...GatsbyDatoCmsSizes_noBase64
          }
          tallSizes: sizes(maxWidth: 300, imgixParams: { auto: "compress", rect: "300,600,840,900" }) {
            ...GatsbyDatoCmsSizes_noBase64
          }
        }
      }
    }

    collection: datoCmsCollection(slug: { eq: $slug }, locale: { eq: $locale }) {

      seo: seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }

      id
      name
      slug
      instructionManual {
        url
      }
      dataSheet {
        url
      }
      about: aboutNode {
        markdown: childMarkdownRemark {
          html
        }
      }
      interchangeable
      priceStartingFrom
      buyLink

      color {
        hex
      }

      designers {
        name
        slug
        smallDescription: smallDescriptionNode {
          markdown: childMarkdownRemark {
            html
            excerpt: excerpt(pruneLength:300)
          }
        }
        avatar {
          url
          title
          alt
          resize(width: 200, height: 200, imgixParams: { fm: "jpg", auto: "compress", fit: "crop" }) {
            src
          }
        }
      }

      threesixty {
        isTall
        frames {
          title
          alt
          normal: resize(width: 600, imgixParams: { auto: "compress", rect: "300,400,840,900" }) {
            src
          }
          tall: resize(width: 600, imgixParams: { auto: "compress", rect: "300,600,840,900" }) {
            src
          }
          sizes(maxWidth: 300, imgixParams: { auto: "compress", rect: "300,400,840,900" }) {
            ...GatsbyDatoCmsSizes
          }
        }
      }

      gallery {
        id
        url
        width
        height
        title
        alt
        sizes(maxWidth: 600, imgixParams: { fm: "jpg", auto: "compress" }) {
          ...GatsbyDatoCmsSizes
        }
      }

      news {
        title
        slug
        date
        abstract
        cover {
          title
          alt
          resize(width: 800, imgixParams: { auto: "compress" }) {
            src
          }
        }
      }

      combos {
        name
        isTall
        baseBits {
          id
          draft
          defaultPrice
          code
          name
          canHaveFeet
          stoolOption
          designer {
            name
            slug
            smallDescription: smallDescriptionNode {
              markdown: childMarkdownRemark {
                html
                excerpt: excerpt(pruneLength:300)
              }
            }
            avatar {
              url
              title
              alt
              resize(width: 200, height: 200, imgixParams: { fm: "jpg", auto: "compress", fit: "crop" }) {
                src
              }
            }
          }
          colors {
            id
            code
            sku
            price
            name
            swatch {
              resize(width: 100, imgixParams: { auto: "compress" }) {
                src
              }
            }
            bitImage {
              url
              normal: resize(width: 600, imgixParams: { auto: "compress", rect: "300,400,840,900" }) {
                src
              }
              tall: resize(width: 600, imgixParams: { auto: "compress", rect: "300,400,840,1150" }) {
                src
              }
            }
          }
        }
        optionalBits {
          id
          draft
          code
          defaultPrice
          name
          softpadPreview {
            image {
              resize(width: 600, imgixParams: { auto: "compress", rect: "300,400,840,900" }) {
                src
              }
            }
          }
          mysecondskinPreview {
            image {
              resize(width: 600, imgixParams: { auto: "compress", rect: "300,400,840,900" }) {
                src
              }
            }
          }
          designer {
            name
            slug
            avatar {
              url
              resize(width: 200, height: 200, imgixParams: { fm: "jpg", auto: "compress", fit: "crop" }) {
               src
              }
            }
          }
          colors {
            id
            code
            sku
            price
            name
            swatch {
              resize(width: 100, imgixParams: { auto: "compress" }) {
                src
              }
            }
            bitImage {
              url
              normal: resize(width: 600, imgixParams: { auto: "compress", rect: "300,400,840,900" }) {
                src
              }
              tall: resize(width: 600, imgixParams: { auto: "compress", rect: "300,400,840,1150" }) {
                src
              }
            }
          }
        }
      }
    }

    accessoriesModal: allDatoCmsAccessoriesModal(filter: { locale: { eq: $locale } }) {
      edges {
        node {
          title
          slug
          link
          modalImage {
            title
            alt
            resize(width: 600, imgixParams: { auto: "compress" }) {
              src
            }
          }
          designers {
            name
          }
        }
      }
    }

    menuHomepage:           datoCmsHomepage(locale: { eq: $locale })           { menuTitle themeColor { hex } }
    menuInterchangeability: datoCmsInterchangeability(locale: { eq: $locale }) { menuTitle themeColor { hex } slug }
    menuPhilosophy:         datoCmsPhilosophy(locale: { eq: $locale })         { menuTitle themeColor { hex } slug }
    menuNews:               datoCmsNewsHome(locale: { eq: $locale })           { menuTitle themeColor { hex } slug }
    menuAbout:              datoCmsAbout(locale: { eq: $locale })              { menuTitle themeColor { hex } slug }
    menuContact:            datoCmsContact(locale: { eq: $locale })            { menuTitle themeColor { hex } slug }
    menuCatalog:            datoCmsCatalog(locale: { eq: $locale })            { menuTitle themeColor { hex } slug }
    menuDownload:           datoCmsDownloadArea(locale: { eq: $locale })       { menuTitle themeColor { hex } slug }
    menuDesigners:          datoCmsDesignersPage(locale: { eq: $locale })      { menuTitle themeColor { hex } slug }
    menuFooter:             datoCmsFooter                                      { facebook instagram twitter youtube pinterest companyName address: addressNode { markdown: childMarkdownRemark { html } } googleMapsUrl phoneNumber faxNumber vat emailAddress newsletterTitle newsletterDescription}
  }
`



// WEBPACK FOOTER //
// ./src/templates/collection.js